import { useContext, useEffect } from "react";
import GeaoLayout from "../shared/Layout/GeaoLayout";
import { GeaoContext } from "../../GeaoContextProvider";
import { GdkCheckpoint } from "@gdk/checkpoint";
import useTitle from "../../../../hooks/useTitle";

export default function ProducerBackgroundCheckInProgress() {
    useTitle("Application Status");

    const { agentInterview } = useContext(GeaoContext);

    useEffect(() => {
        new GdkCheckpoint({
            content: `#overview-checkpoint`,
            data: [
                {
                    title: "Create Profile",
                    status: "completed"
                },
                {
                    title: "Complete Application",
                    status: "completed"
                },
                {
                    title: "Pass Background Check",
                    status: "in process"
                },
                {
                    title: "Start Selling with GEICO"
                }
            ],
            animated: false
        });
    }, []);

    return <GeaoLayout header="Application Status">
        <div className="margin-top margin-bottom container">
            <p className="font--bold" style={{ color: "#616161" }}>Your background check is in progress</p>
            <h3>Welcome back, {agentInterview?.questionAnswers?.FirstName?.answer}.</h3>

            <div className="bordered-box w-100 p-1 flex-row margin-top">
                <div className="checkpoint p-3 m-2 background overview-block" id="overview-checkpoint" style={{ flexBasis: "375px", flexGrow: 0, flexShrink: 0 }}>
                    <p className="checkpoint checkpoint-heading">What's Next?</p>
                    <ul className="checkpoint-content"></ul>
                </div>
                <div className="m-2">
                    <h4 className="margin-top">Your background check is in progress</h4>
                    <p>
                        We’ll let you know when your background check is finished. Once passed, you’ll receive an email with login credentials inviting you to start selling with GEICO.
                    </p>
                </div>
            </div>
        </div>
    </GeaoLayout>
}